import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import SingleSkeletonProduct from "./SingleSkeletonProduct";

const SkeletonProductSlider = () => {
    return (
        <div className="skeleton-product-slider-wrapper xmt-20">
            <div className="container">
                <div className="header-slider">
                    <div className="more-icon d-flex justify-content-end"><IconName name="chevron_left"
                                                                                    className="icon"/></div>
                    <div className="border-slider xmt-2 position-relative">
                        <div className="active-border position-absolute"></div>
                    </div>
                </div>
            <div className="slider-wrapper xmt-6 d-flex">
                <SingleSkeletonProduct color="blue"/>
                <SingleSkeletonProduct color="blue"/>
                <SingleSkeletonProduct color="blue"/>
                <SingleSkeletonProduct color="blue"/>
            </div>
            </div>
        </div>
    );
};

export default SkeletonProductSlider;
